import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from '../../reducers/auth';
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

const Product = (props) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const navigate = useNavigate();
  const loginStatus = useSelector(isLoggedIn);
  const [imgSrc, setImgSrc] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);

  const imageOver = (item) => {
    setImgSrc(item.modelImage);
    setCurrentColor(item);
  }
  var showColors = true;
  if (props.showColors && props.showColors === "hide") {
    showColors = false;
  }
  let featuredColor = null;
  if (props.product.featuredColor != null) {
    for (var i = 0; i < props.product.colors.length; i++) {
      if (props.product.colors[i].colorId === props.product.featuredColor) {
        featuredColor = props.product.colors[i];
      }
    }
  }
  if (featuredColor === null)
    featuredColor = props.product.colors[0];

  console.log("PRODUCT", props.baseUrl);

  return (
    <Col xs={12} sm={6} md={4} lg={2} style={{ paddingRight: 4, paddingLeft: 4, paddingBottom: 4, paddingTop: 4 }}>
      <div className="product">
        <div onClick={() => { navigate(props.url ? props.url + props.product.id : `../admin/product/details/` + props.product.id, { state: { productId: props.product.id, colorId: currentColor?.colorId }, replace: true }); }}>
          <div className="modelImage"><img src={props.baseUrl ? props.baseUrl + featuredColor.modelImage : "" + featuredColor.modelImage} alt="Model Image" width="100%" /></div>
          <div className="title">{props.product.title}</div>
          {loginStatus ? (
            <div className="price">${props.product.costSingle2X}</div>
          ) : null}
          <div className="colors">
            <div style={{ width: "100%", textAlign: "center" }}>
              {props.product.colorCount} Colors available
            </div>
          </div>
          {showColors &&
            <Container>
              <Row>
                <Col className="colors">
                  {props.product.colors.map((color, idx) => (
                    <div className={`color-swatch`}>
                      {color.hexColor && color.hexColor != "" && (
                        <div style={{ backgroundColor: color.hexColor, width: 20, height: 20 }}></div>
                      )}
                      {color.colorImage && color.colorImage != "" && (
                        <img src={`https://cdnm.sanmar.com/swatch/gifs/${color.colorImage}`} alt={`${color.colorName}`} height={20}
                          onMouseOver={(event) => imageOver(color)}
                        />
                      )}
                    </div>
                  ))}

                </Col>
              </Row>
            </Container>
          }
        </div>
      </div>
    </Col>
  );
};

export default Product;